import { Box, Typography, Avatar } from "@mui/material";
import { motion } from "framer-motion";
import { capitalize } from "../../../config/settings.config";

const MotionBox = motion.create ? motion.create(Box) : motion(Box);

const formatDateTime = (dateInput) => {
  if (!dateInput) return "-";
  const date = new Date(dateInput);
  if (isNaN(date)) return "-";
  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const getInitials = (name) => {
  if (!name) return "U";
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
};

const LogItem = ({
  time,
  rnr,
  notes,
  employee,
  callSourceFromLog,
  duration,
  index,
  theme,
}) => {
  const callOutcome = rnr ? "RNR" : "Answered";

  return (
    <MotionBox
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      whileHover={{ scale: 1.01 }}
      sx={{
        p: 2.5,
        bgcolor: "#FAFAFA",
        borderRadius: 3,
        border: "1px solid #F1F5F9",
        transition: "all 0.3s ease",
        "&:hover": {
          bgcolor: "#F8FAFC",
          borderColor: "#E2E8F0",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        },
      }}
    >
      {/* Top Row: Notes Title and Time */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          mb: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: 15,
            fontWeight: 600,
            color: "#1E293B",
            lineHeight: 1.4,
            flex: 1,
            mr: 2,
          }}
        >
          {notes || (rnr ? "Missed Call" : "Call")}{" "}
          {callSourceFromLog && `– ${capitalize(callSourceFromLog)}`}
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            color: "#94A3B8",
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          {formatDateTime(time)}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        {/* Avatar */}
        <Avatar
          sx={{
            width: 32,
            height: 32,
            fontSize: 13,
            fontWeight: 600,
            bgcolor: theme?.palette.primary.main || "#7C3AED",
            color: "#FFFFFF",
            flexShrink: 0,
          }}
        >
          {getInitials(employee)}
        </Avatar>

        {/* Username */}
        <Typography
          sx={{
            fontSize: 13,
            color: "#64748B",
          }}
        >
          Logged by{" "}
          <span
            style={{
              color: theme?.palette.primary.main || "#7C3AED",
              fontWeight: 600,
            }}
          >
            {employee || "Unknown"}
          </span>
        </Typography>

        {/* Call Outcome Badge */}
        {callOutcome && (
          <Box
            sx={{
              px: 1.5,
              py: 0.5,
              borderRadius: 2,
              fontSize: 11,
              fontWeight: 600,
              whiteSpace: "nowrap",
              bgcolor:
                callOutcome === "Answered"
                  ? duration <= 5
                    ? "rgba(239, 68, 68, 0.1)"
                    : "rgba(16, 185, 129, 0.1)"
                  : "rgba(239, 68, 68, 0.1)",
              color:
                callOutcome === "Answered"
                  ? duration <= 5
                    ? "#EF4444"
                    : "#10B981"
                  : "#EF4444",
            }}
          >
            {callOutcome === "Answered" ? `Answered-${duration}s` : "RNR"}
          </Box>
        )}
      </Box>
    </MotionBox>
  );
};

export default LogItem;
